document.addEventListener("DOMContentLoaded", function () {
  const optionOne = document.querySelector(".option-one");
  const optionTwo = document.querySelector(".option-two");
  const optionOneActive = document.querySelector(".option-oneActive");
  const optionTwoActive = document.querySelector(".option-twoActive");
  const optionOneLabel = optionOne.parentElement;
  const optionTwoLabel = optionTwo.parentElement;
  const closeButton = document.querySelector(".close-button");
  const stickyBarSection = document.querySelector(".sticky-bar-section");

  function updateLabels() {
    if (optionOne.checked) {
      optionOneLabel.classList.add("selected");
      optionTwoLabel.classList.remove("selected");
    } else {
      optionOneLabel.classList.remove("selected");
      optionTwoLabel.classList.add("selected");
    }
  }

  optionOne.addEventListener("change", function () {
    if (optionOne.checked) {
      optionOneActive.style.display = "flex";
      optionTwoActive.style.display = "none";
      updateLabels();
    }
  });

  optionTwo.addEventListener("change", function () {
    if (optionTwo.checked) {
      optionOneActive.style.display = "none";
      optionTwoActive.style.display = "flex";
      updateLabels();
    }
  });

  closeButton.addEventListener("click", function () {
    stickyBarSection.style.display = "none";
  });

  if (!optionOne.checked && !optionTwo.checked) {
    optionOne.checked = true;
    optionOneActive.style.display = "flex";
  }

  updateLabels();
});
